import axios from "axios";
import { Realm } from "../interfaces/RealmInterface";

export const getRealms = async () => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const {
      data: { data: realms },
    } = await axios({
      method: "get",
      url: `${process.env.REACT_APP_AUTH_API}/realms`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return {
      data: realms as Realm[],
    };
  } catch (e) {
    console.error("Failed to get realms list:", e);
    throw e;
  }
};
